import { render, staticRenderFns } from "./CountryDetail.vue?vue&type=template&id=4ecf31b8&scoped=true"
import script from "./CountryDetail.vue?vue&type=script&lang=js"
export * from "./CountryDetail.vue?vue&type=script&lang=js"
import style0 from "./CountryDetail.vue?vue&type=style&index=0&id=4ecf31b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf31b8",
  null
  
)

export default component.exports